document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-whatsapp-button]').forEach((container) => {
    const closeButton = container.querySelector('[data-whatsapp-close]');

    if (!closeButton) {
      return;
    }

    closeButton.addEventListener('click', () => {
      container.hidden = true;
    });
  });
});
